import { ButtonEnums, Icon } from '@ohif/ui';
import { Button } from '@ohif/ui';
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  Icons,
  Input,
  Separator,
} from '@ohif/ui-next';
import React, { ReactElement, useCallback, useState } from 'react';
import { useForm } from 'react-hook-form';
import z from 'zod';
import { zodResolver } from '@hookform/resolvers/zod';
import { VscLoading } from 'react-icons/vsc';
import { useTranslation } from 'react-i18next';

const formSchema = z.object({
  reasonDelete: z
    .string({ message: 'Reason delete series is required!' })
    .min(1, { message: 'Reason delete series is required!' }),
});

function DeleteSeries({ onClose, isLoading, onSubmit, type = 'series' }) {
  const form = useForm<z.infer<typeof formSchema>>({
    resolver: zodResolver(formSchema),
  });

  const onHandleSubmit = async (values: any) => {
    // window.onload
    onSubmit(values.reasonDelete);
  };
  return (
    <div className="bg-primary-dark flex h-full w-full max-w-[900px] flex-col gap-2 rounded-md p-3">
      {/* <div className="justity-between flex w-full">
        <h3 className="text-primary-light w-full font-medium">Konfirmasi Hapus</h3>
        <Icon
          onClick={onClose}
          name="close"
          className="text-primary-active cursor-pointer"
        />
      </div> */}
      {/* <Separator className="bg-gray-300 opacity-50" /> */}
      <div className="bg-primary-dark text-wrap mb-4 text-white">
        {type === 'series' ? (
          <p>
            Apakah Anda yakin ingin hapus <b className="uppercase text-red-400">series</b> ini?{' '}
            <b className="uppercase text-red-400">Series</b> yang dihapus tidak dapat dikembalikan.
          </p>
        ) : (
          <p>
            Apakah Anda yakin ingin hapus <b className="uppercase text-red-400">instance</b> yang
            sedang tampil di viewer saat ini? <b className="uppercase text-red-400">Instance</b>{' '}
            yang dihapus tidak dapat dikembalikan.
          </p>
        )}
      </div>
      <Form {...form}>
        <form
          onSubmit={form.handleSubmit(onHandleSubmit)}
          className="flex h-full w-full flex-col gap-2"
        >
          <FormField
            control={form.control}
            name="reasonDelete"
            render={({ field }) => (
              <div className="flex w-full flex-col gap-1">
                <FormItem className="flex w-full flex-col gap-2 space-y-[4px]">
                  {/* Agar field menyesuaikan lebar */}
                  <FormLabel className="text-start">
                    {type === 'series'
                      ? 'Mohon masukkan alasan series perlu dihapus'
                      : 'Mohon masukkan alasan instance perlu dihapus'}
                  </FormLabel>
                  <Input
                    {...field}
                    type="text"
                    className="w-full"
                  />
                </FormItem>
                <FormMessage />
              </div>
            )}
          />

          <div className="mt-4 flex justify-end gap-2 text-white">
            <Button
              // className="ml-2"
              disabled={isLoading}
              // onClick={downloadImage}
              type={ButtonEnums.type.primary}
              // type="submit"
              name={'HAPUS'}
            >
              {isLoading ? (
                <VscLoading className="mr-2 h-4 w-4 animate-spin" />
              ) : (
                <Icons.Trash className="h-[20px] w-[20px]" />
              )}
              HAPUS
            </Button>
            <Button
              name="cancel"
              type={ButtonEnums.type.secondary}
              onClick={e => {
                e.preventDefault();
                onClose();
              }}
              disabled={isLoading}
            >
              BATAL
            </Button>
          </div>
        </form>
      </Form>
    </div>
  );
}

export default DeleteSeries;
